import { render, staticRenderFns } from "./OverlayQrCodeFollow.vue?vue&type=template&id=a70438d4&scoped=true"
import script from "./OverlayQrCodeFollow.vue?vue&type=script&lang=js"
export * from "./OverlayQrCodeFollow.vue?vue&type=script&lang=js"
import style0 from "./OverlayQrCodeFollow.vue?vue&type=style&index=0&id=a70438d4&prod&lang=scss&scoped=true"
import style1 from "./OverlayQrCodeFollow.vue?vue&type=style&index=1&id=a70438d4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/.pnpm/vue-loader@15.11.1_nl733cueh6kngwrfuxx6f6mp5u/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a70438d4",
  null
  
)

export default component.exports